import React from 'react';
import DefaultView from '@plone/volto/components/theme/View/DefaultView';
import useLook from '../Look/useLook';
import ClassicHome from './ClassicHome';

// The site root: the redesigned home page (its blocks), or the old site's
// home page when the classic look is on
const HomeView = (props) =>
  useLook() === 'classic' ? (
    <ClassicHome {...props} />
  ) : (
    <DefaultView {...props} />
  );

export default HomeView;
